var _rect, _rect2, _rect3, _rect4, _rect5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrafficData = function SvgTrafficData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 64 64"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.468,
    height: 9.01,
    x: 4.385,
    y: 38.901,
    rx: 1,
    transform: "rotate(-45 9.112 43.411)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 12,
    x: 15,
    y: 48.244,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 16.143,
    x: 27,
    y: 44.101,
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 22.571,
    x: 39,
    y: 37.673,
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 28,
    x: 51,
    y: 32.244,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.928 40.076a1 1 0 0 0 1.414 0l4.329-4.329a17.693 17.693 0 1 0-3.892-3.893l-4.329 4.329a1 1 0 0 0 0 1.414zm7.018-27.771a12.922 12.922 0 1 1 0 18.274 12.93 12.93 0 0 1 0-18.274"
  })));
};
export default SvgTrafficData;